export function setVideo() {

  /* Elements */
  let video = document.getElementById('js-video');
  let srcPc = video.getAttribute('data-pc');
  let srcSp = video.getAttribute('data-sp');

  /* Common settings */
  const mediaQuery = matchMedia('(max-width: 768px)');
  video.removeAttribute('data-pc');
  video.removeAttribute('data-sp');

  /* Video settings */
  video.load();
  video.controls = false; // コントロールバー非表示
  video.loop = true; // ループ
  video.muted = true; // ミュート

  /* init */
  mediaQuery.addListener(onMediaQueryChanage);
  onMediaQueryChanage(mediaQuery);

  /* functions */
  function onMediaQueryChanage(mediaQuery) {
    if (mediaQuery.matches === true) {
      video.src = srcSp;
    } else {
      video.src = srcPc;
    }
  }

}

export function playVideo() {

  /* Elements */
  let video = document.getElementById('js-video');

  /* Common settings */
  const mediaQuery = matchMedia('(max-width: 768px)');

  /* 自動再生 */
  video.autoplay = true;

  /* init */
  mediaQuery.addListener(onMediaQueryChanage);
  onMediaQueryChanage(mediaQuery);

  /* functions */
  function onMediaQueryChanage(mediaQuery) {
    if (mediaQuery.matches === true) {
      video.play();
    } else {
      video.play();
    }
  }

}